<template>
    <v-text-field v-model="email"
                  label="Email Address"
                  outlined
                  dense
                  placeholder="Enter email address"
                  :rules="required ? emailRules : []"
                  @input="$emit('input', email)"></v-text-field>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
                default: null,
            },
            required: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
                email: this.value,
                emailRules: [
                    v => !!v || this.$t('RequiredField'),
                    v => /.+@.+\..+/.test(v) || this.$t('InvalidEmail'),
                ],
            }
        },
        watch: {
            value(oldValue, newValue) {
                this.email = oldValue
            }
        },

    }
</script>

<style scoped>
</style>
